(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Seam tagging moved to the in-flow seam engine (brave-prototype-seam.js). This file now owns
  // only the scroll reveals.

  function tagReveal() {
    var secs = document.querySelectorAll('#MainContent > .shopify-section');
    secs.forEach(function (s, idx) {
      if (idx === 0) return;
      if (!s.hasAttribute('data-reveal')) s.setAttribute('data-reveal', '');
    });
  }

  function observe() {
    if (!('IntersectionObserver' in window) || reduce) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) { io.observe(el); });
  }

  function init() { tagReveal(); observe(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
